import { Component, ComponentRef, inject, Injectable, Type } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DynamicRouteHandlingService {
  #router = inject(Router);

  submitButton: Subject<void> = new Subject<void>();
  submitButton$ = this.submitButton.asObservable();

  componentRef: BehaviorSubject<ComponentRef<any> | null> = new BehaviorSubject<ComponentRef<any> | null>(null);
  componentRef$ = this.componentRef.asObservable();

  closeModal: Subject<void> = new Subject<void>();
  closeModal$ = this.closeModal.asObservable();

  reload: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  reload$ = this.reload.asObservable();

  // dynamicRouteHandling(route: string, queryParams?: any) {
  //   this.#router.navigate([route], { queryParams });
  // }
}
